<template>
  <section v-loading="listLoading" class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="locale" label="地区" width="200px;"></el-table-column>
        <el-table-column prop="title" label="标题" width="200px;"></el-table-column>
        <el-table-column prop="emails" label="邮箱地址">
          <template #default="{ row }">
            <a v-if="row.emails" style="color: blue" @click="showEmails(row.emails)">点击查看</a>
            <span v-else>全部用户</span>
          </template>
        </el-table-column>
        <el-table-column prop="replyTo" label="回复地址"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="{ row }">
            {{
              row.status === 0
                ? "待发送"
                : row.status === 1
                ? "发送成功"
                : row.status === 2
                ? "发送失败"
                : "取消发送"
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createUserId" label="创建人编号"></el-table-column> -->
        <el-table-column prop="createUserName" label="创建人名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template #default="{ row }">{{ row.createTime | formatDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="updateUserId" label="更新人编号"></el-table-column> -->
        <el-table-column prop="updateUserName" label="更新人名称"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间">
          <template #default="{ row }">{{ row.updateTime | formatDate }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown type="primary" @command="handleCommand">
              <el-button type="primary" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item :command="{ type: 'edit', index: scope.$index, data: scope.row }"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'delete', index: scope.$index, data: scope.row }"
                  >删除</el-dropdown-item
                > -->
                <el-dropdown-item :command="{ type: 'send', index: scope.$index, data: scope.row }"
                  >发送</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'cancel', index: scope.$index, data: scope.row }"
                  >取消</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'sendLog', index: scope.$index, data: scope.row }"
                  >发送记录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="Create" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="Locale">
          <el-select v-model="addForm.locale">
            <el-option value="PH" label="Philippines" />
            <el-option value="AUS" label="Australia" />
            <el-option value="MYS" label="Malaysia" />
          </el-select>
        </el-form-item>
        <el-form-item label="Subject">
          <el-input v-model="addForm.title" placeholder="Email subject"></el-input>
        </el-form-item>
        <el-form-item label="Email content">
          <html-editor :key="key" v-model="addForm.content" />
        </el-form-item>
        <el-form-item label="Emails">
          <el-input
            v-model="addForm.emails"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            placeholder="Line by line, If null it will be sent to all users"
          ></el-input>
        </el-form-item>
        <el-form-item label="Reply to">
          <el-input v-model="addForm.replyTo" placeholder="Reply to"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <email-send-log ref="emailSendLog" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import HtmlEditor from "@/components/HtmlEditor";
import EmailSendLog from "./components/EmailSendLog";

import mainHeight from "@/utils/mainHeight";
export default {
  name: "EmailSend",
  components: { MyPagination, HtmlEditor, EmailSendLog },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      key: new Date().getTime(),
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    showEmails(emails) {
      this.$alert(`<pre>${emails}</pre>`, "邮箱地址", {
        dangerouslyUseHTMLString: true,
      });
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/email-send/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        case "send":
          this.send(cmd.index, cmd.data);
          break;
        case "cancel":
          this.cancel(cmd.index, cmd.data);
          break;
        case "sendLog":
          this.sendLog(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.key = new Date().getTime();
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/email-send/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete("mall:/api/admin/email-send/" + row.id)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async send(index, row) {
      const me = this;
      this.$confirm("是否确认发送?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("mall:/api/admin/email-send/send?id=" + row.id)
            .then((data) => {
              me.$message({ message: "发送任务提交成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {});
    },
    async cancel(index, row) {
      const me = this;
      this.$confirm("是否确认取消?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("mall:/api/admin/email-send/cancel?id=" + row.id)
            .then((data) => {
              me.$message({ message: "取消成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {});
    },
    sendLog(index, row) {
      this.$refs.emailSendLog.show(row.id);
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
